import { createContext, createElement, Dispatch, SetStateAction } from 'react'

import { ConfigurationBaseOptions } from '@scouts/bookkeeping'
import { CountryCode, CurrencyCode, CurrencySymbol, Locale, TimeZone } from '@scouts/helpers'

import config from '@/config'
import {
    CURRENCY,
    PATH_NEW_ONBOARDING_INVOICING,
    PATH_NEW_ONBOARDING_SELF_EMPLOYED_PROFILE,
    PATH_PROFILE_SUBSCRIPTIONS,
    PATH_PROFILE_SUBSCRIPTIONS_HASH_BOOKKEEPING,
} from '@/constants'
import { featureFlags } from '@/feature-flags'
import { getBaseUrl, getFullBasenamePath } from '@/helpers/url-domain'
import history from '@/history'

import { getAccessToken } from '@/components/auth/get-access-token'
import { BankingPromotionBanner } from '@/components/finances/BankingPromotionBanner'
import { BankingPromotionParagraph } from '@/components/finances/BankingPromotionParagraph'

export const DEFAULT_CONTEXT: ConfigurationBaseOptions = {
    defaultCurrency: CurrencyCode[CURRENCY],
    defaultCurrencySymbol: CurrencySymbol[CURRENCY],
    featureFlags,
    countryCode: CountryCode.ES,
    locale: Locale.ES,
    timeZone: TimeZone.ES,
    appBasename: getFullBasenamePath(),
    baseUrl: getBaseUrl(),
    rootPath: null,
    invoicingOnboardingPath: PATH_NEW_ONBOARDING_INVOICING,
    selfEmployedOnboardingPath: PATH_NEW_ONBOARDING_SELF_EMPLOYED_PROFILE,
    availableDateRangeFilterShortcuts: [],
    client: {
        url: config.apiUrlBookkeeping,
        token: getAccessToken,
    },
    bankingPromotion: {
        renderBankingPromotionBanner: createElement(BankingPromotionBanner),
        renderBankingPromotionParagraph: createElement(BankingPromotionParagraph),
    },
    navigateToProfileSubscriptions: () =>
        history.push({ pathname: PATH_PROFILE_SUBSCRIPTIONS, hash: PATH_PROFILE_SUBSCRIPTIONS_HASH_BOOKKEEPING }),
}

export const BookkeepingConfigurationContext = createContext<
    [ConfigurationBaseOptions, Dispatch<SetStateAction<ConfigurationBaseOptions>>]
>([DEFAULT_CONTEXT, () => {}])
